import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  AiPromptTemplatesEntry,
  AiPromptTemplatesState,
  FetchTemplatesFailurePayload,
  FetchTemplatesKeyPayload,
  FetchTemplatesRequestPayload,
  FetchTemplatesSuccessPayload,
} from './types';

const initialState: AiPromptTemplatesState = {};

const idleEntry: AiPromptTemplatesEntry = { status: 'idle', items: [] };

const aiPromptTemplatesSlice = createSlice({
  name: 'aiPromptTemplates',
  initialState,
  reducers: {
    fetchTemplatesRequest: (
      state,
      action: PayloadAction<FetchTemplatesRequestPayload>,
    ) => {
      state[action.payload.key] = { status: 'loading', items: [] };
    },
    fetchTemplatesSuccess: (
      state,
      action: PayloadAction<FetchTemplatesSuccessPayload>,
    ) => {
      const { key, items } = action.payload;
      state[key] = { status: 'ready', items };
    },
    fetchTemplatesFailure: (
      state,
      action: PayloadAction<FetchTemplatesFailurePayload>,
    ) => {
      const { key, error } = action.payload;
      state[key] = { status: 'error', items: [], error };
    },
    resetTemplates: (
      state,
      action: PayloadAction<FetchTemplatesKeyPayload>,
    ) => {
      delete state[action.payload.key];
    },
  },
});

export const {
  fetchTemplatesRequest,
  fetchTemplatesSuccess,
  fetchTemplatesFailure,
  resetTemplates,
} = aiPromptTemplatesSlice.actions;

export const selectPromptTemplates =
  (key: string) =>
  (state: {
    aiPromptTemplates: AiPromptTemplatesState;
  }): AiPromptTemplatesEntry =>
    state.aiPromptTemplates[key] || idleEntry;

export const aiPromptTemplatesReducer = aiPromptTemplatesSlice.reducer;

export default aiPromptTemplatesSlice;
